import React, { ChangeEvent, FC } from 'react';
import Signature from '../../../signature/signature';
import {
    Autocomplete,
    CircularProgress,
    Grid,
    MenuItem,
    Alert,
    Box
} from '@mui/material';
import { formatDecimalNumber } from '../../../../utils/helper';
import Quotefield from '../../../../pages/dashboard/tradedocuments/quotation/quotefield/quotefield';
import NewCustomSelect from '../../../newcustomselect/newcustomselect';
import Customdatepicker from '../../../customdatepicker/customdatepicker';
import {
    medthodsOfDispatch,
    typesOfShipment
} from '../../../../utils/appconstants';
import ChooseDocUpload from '../../../custommodal/ChooseDocUpload';
import UploadLogo from '../common/UploadLogo';
import PortsAutocomplete from '../../../autocompletewithapi/PortsAutocomplete';
import UploadStamp from '../common/UploadStamp';
import QuotationMobileForm from './FormsMobileView/Quotation';
import {
    Quotation,
    QuotationFormErrors
} from '../../../../interfaces/Quotation';
import { CorporatePartner } from '../../../../interfaces/CorporatePartner';
import { Currency } from '../../../../pages/dashboard/payments/interfaces/Currency';
import { TradeDocumentForm } from '../../../../interfaces/TradeDocument';
import CustomTextField from '../../../CustomTextInput';

export interface QuotationFormProps extends TradeDocumentForm {
    payload: Quotation;
    errors: QuotationFormErrors;
    currencies: Currency[];
    loadingCurrencies: boolean;
}

const QuotationForm: FC<QuotationFormProps> = ({
    error,
    updateField,
    payload,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    currencies,
    addQuoteField,
    loadingCurrencies,
    setSignatureUrlBase64,
    signatureUrlBase64,
    totalAmount,
    activeStep,
    setActiveStep,
    onSaveOnlyAction,
    showPreview,
    setShowPreview
}: QuotationFormProps): JSX.Element => {
    return (
        <>
            <QuotationMobileForm
                {...{
                    updateField,
                    payload,
                    corporatePartners,
                    loadingCorporatepartners,
                    setShowAddPartner,
                    errors,
                    quoteFields,
                    updateQuoteField,
                    removeQuoteField,
                    currencies,
                    addQuoteField,
                    loadingCurrencies,
                    setSignatureUrlBase64,
                    signatureUrlBase64,
                    totalAmount,
                    activeStep,
                    setActiveStep,
                    onSaveOnlyAction,
                    showPreview,
                    setShowPreview
                }}
            />
            <div className='hidden lg:block form-container'>
                <div className='border-0 border-appcolorgreyfaint'>
                    {error !== null && (
                        <div className='mt-10 mb-4'>
                            <Alert severity='error'>{error}</Alert>
                        </div>
                    )}

                    <form>
                        <div>
                            <div className='flex gap-2 items-center'>
                                <UploadLogo {...{ payload, updateField }} />
                                <ChooseDocUpload {...{ updateField, payload }}>
                                    <p>Choose Logo</p>
                                </ChooseDocUpload>

                                <Box className='ml-auto'>
                                    <UploadStamp
                                        {...{ payload, updateField }}
                                    />
                                </Box>
                            </div>
                            <Grid container>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                                marginTop: 0
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={12}>
                                                <NewCustomSelect
                                                    selectValue={
                                                        payload.sellerId as unknown as string
                                                    }
                                                    required
                                                    selectOptions={
                                                        corporatePartners as unknown as (
                                                            | string
                                                            | Record<
                                                                  string,
                                                                  unknown
                                                              >
                                                        )[]
                                                    }
                                                    name={'sellerId'}
                                                    updateField={(_, value) => {
                                                        updateField(
                                                            'sellerId',
                                                            value
                                                        );
                                                        updateField(
                                                            'sellerAddress',
                                                            corporatePartners.filter(
                                                                (
                                                                    item: CorporatePartner
                                                                ) =>
                                                                    item.id ===
                                                                    value
                                                            )[0]?.address
                                                        );
                                                        updateField(
                                                            'sellerCountry',
                                                            corporatePartners.filter(
                                                                (
                                                                    item: CorporatePartner
                                                                ) =>
                                                                    item.id ===
                                                                    value
                                                            )[0]?.bankCountry
                                                        );
                                                        updateField(
                                                            'sellerName',
                                                            corporatePartners.filter(
                                                                (
                                                                    item: CorporatePartner
                                                                ) =>
                                                                    item.id ===
                                                                    value
                                                            )[0]?.name
                                                        );
                                                    }}
                                                    label={'Invoice From'}
                                                    selectOptionLabel='name'
                                                    loading={
                                                        loadingCorporatepartners
                                                    }
                                                    dropdownRender={() => {
                                                        return (
                                                            <div className='px-4 border-t border-appcolorgreyfaint'>
                                                                <p
                                                                    className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                                                    onClick={() => {
                                                                        setShowAddPartner(
                                                                            true
                                                                        );
                                                                    }}
                                                                >
                                                                    + Add a New
                                                                    Partner
                                                                </p>
                                                            </div>
                                                        );
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={3} lg={3}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                                        <CustomTextField
                                            value={payload?.quoteNumber}
                                            error={
                                                errors?.quoteNumber.length > 0
                                            }
                                            helperText={
                                                errors?.quoteNumber.length > 0
                                                    ? errors?.quoteNumber
                                                    : undefined
                                            }
                                            required
                                            id='quotation-quoteNumber'
                                            label='Quote Number'
                                            name='quoteNumber'
                                            onChange={(
                                                e: ChangeEvent<HTMLInputElement>
                                            ) => {
                                                updateField(
                                                    'quoteNumber',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={3} lg={3}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <Customdatepicker
                                            value={payload?.issuedDate || null}
                                            id='quotation-issuedDate'
                                            label='Date'
                                            name='issuedDate'
                                            updateField={updateField}
                                            error={
                                                errors?.issuedDate.length > 0
                                            }
                                            helperText={
                                                errors?.issuedDate.length > 0
                                                    ? errors?.issuedDate
                                                    : undefined
                                            }
                                        />
                                    </div>
                                </Grid>
                            </Grid>

                            <Grid container>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <NewCustomSelect
                                            selectValue={
                                                payload.receiverId as unknown as string
                                            }
                                            required
                                            selectOptions={
                                                corporatePartners as unknown as (
                                                    | string
                                                    | Record<string, unknown>
                                                )[]
                                            }
                                            name={'receiverId'}
                                            updateField={(_, value) => {
                                                updateField(
                                                    'receiverId',
                                                    value
                                                );
                                                updateField(
                                                    'receiverAddress',
                                                    corporatePartners.filter(
                                                        (
                                                            item: CorporatePartner
                                                        ) => item.id === value
                                                    )[0]?.address
                                                );
                                                updateField(
                                                    'receiverCountry',
                                                    corporatePartners.filter(
                                                        (
                                                            item: CorporatePartner
                                                        ) => item.id === value
                                                    )[0]?.bankCountry
                                                );
                                                updateField(
                                                    'receiverName',
                                                    corporatePartners.filter(
                                                        (
                                                            item: CorporatePartner
                                                        ) => item.id === value
                                                    )[0]?.name
                                                );
                                            }}
                                            label={'Invoice  To'}
                                            selectOptionLabel='name'
                                            loading={loadingCorporatepartners}
                                            dropdownRender={() => {
                                                return (
                                                    <div className='px-4 border-t border-appcolorgreyfaint'>
                                                        <p
                                                            className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                                            onClick={() => {
                                                                setShowAddPartner(
                                                                    true
                                                                );
                                                            }}
                                                        >
                                                            + Add a New Partner
                                                        </p>
                                                    </div>
                                                );
                                            }}
                                        />

                                        <div className='mt-4'>
                                            <CustomTextField
                                                error={
                                                    errors?.salesContractNumber
                                                        ?.length > 0
                                                }
                                                helperText={
                                                    errors?.salesContractNumber
                                                        ?.length > 0
                                                        ? errors?.salesContractNumber
                                                        : undefined
                                                }
                                                value={
                                                    payload?.salesContractNumber
                                                }
                                                id='quotation-salesContractNumber'
                                                label='Sales Contract Number'
                                                name='salesContractNumber'
                                                onChange={(
                                                    e: ChangeEvent<HTMLInputElement>
                                                ) => {
                                                    updateField(
                                                        'salesContractNumber',
                                                        e.target.value
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={3} lg={3}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                                        <PortsAutocomplete
                                            errorCondition={
                                                errors?.portOfLoadingId.length >
                                                0
                                            }
                                            helperText={
                                                errors?.portOfLoadingId.length >
                                                0
                                                    ? errors?.portOfLoadingId
                                                    : undefined
                                            }
                                            id='quotation-portOfLoading'
                                            label='Port of Loading'
                                            name='portOfLoadingId'
                                            updateField={updateField}
                                            nameValue='portOfLoadingValue'
                                            isRequired={true}
                                            value={payload.portOfLoadingValue}
                                        />

                                        <div className='mt-4'>
                                            <CustomTextField
                                                value={
                                                    payload?.methodOfDispatch
                                                }
                                                select
                                                error={
                                                    errors?.methodOfDispatch
                                                        .length > 0
                                                }
                                                helperText={
                                                    errors?.methodOfDispatch
                                                        .length > 0
                                                        ? errors?.methodOfDispatch
                                                        : undefined
                                                }
                                                required
                                                id='quotation-methodOfDispatch'
                                                label='Method of Dispatch'
                                                name='methodOfDispatch'
                                                onChange={(
                                                    e: ChangeEvent<HTMLInputElement>
                                                ) => {
                                                    updateField(
                                                        'methodOfDispatch',
                                                        e.target.value
                                                    );
                                                }}
                                            >
                                                {medthodsOfDispatch.map(
                                                    (item, index) => (
                                                        <MenuItem
                                                            value={item}
                                                            key={`medthodsOfDispatch-${item}-${index}`}
                                                        >
                                                            {item}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </CustomTextField>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={3} lg={3}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4'>
                                        <PortsAutocomplete
                                            errorCondition={
                                                errors?.portOfDischargeId
                                                    .length > 0
                                            }
                                            helperText={
                                                errors?.portOfDischargeId
                                                    .length > 0
                                                    ? errors?.portOfDischargeId
                                                    : undefined
                                            }
                                            id='quotation-portOfDischargeId'
                                            label='Port of Discharge'
                                            name='portOfDischargeId'
                                            isRequired={true}
                                            updateField={updateField}
                                            nameValue='portOfDischargeValue'
                                            value={payload.portOfDischargeValue}
                                        />
                                        <div className='mt-4'>
                                            <CustomTextField
                                                value={payload?.typeOfShipment}
                                                select
                                                error={
                                                    errors?.typeOfShipment
                                                        .length > 0
                                                }
                                                helperText={
                                                    errors?.typeOfShipment
                                                        .length > 0
                                                        ? errors?.typeOfShipment
                                                        : undefined
                                                }
                                                required
                                                id='quotation-typeOfShipment'
                                                label='Type of Shipment'
                                                name='typeOfShipment'
                                                onChange={(
                                                    e: ChangeEvent<HTMLInputElement>
                                                ) => {
                                                    updateField(
                                                        'typeOfShipment',
                                                        e.target.value
                                                    );
                                                }}
                                            >
                                                {typesOfShipment.map(
                                                    (item, index) => (
                                                        <MenuItem
                                                            value={item}
                                                            key={`typesOfShipment-${item}-${index}`}
                                                        >
                                                            {item}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </CustomTextField>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>

                        {quoteFields.map((item, index) => (
                            <Quotefield
                                item={item}
                                key={item.id}
                                index={index}
                                id={item.id ?? ''}
                                updateQuoteField={updateQuoteField}
                                price={item.price ?? 0}
                                qty={item.qty ?? 0}
                                removeQuoteField={removeQuoteField}
                            />
                        ))}

                        <div>
                            <div className='border border-appcolorgreyfaint px-[1rem] pt-8 pb-8'>
                                <div
                                    className='flex items-center cursor-pointer w-fit'
                                    onClick={() => {
                                        addQuoteField();
                                    }}
                                >
                                    <div>
                                        <img
                                            src='/img/vectors/primarydownload.svg'
                                            alt='primarydownload'
                                            className='w-6'
                                        />
                                    </div>
                                    <span className='pl-2 text-appcolorprimary'>
                                        Add Field
                                    </span>
                                </div>
                            </div>

                            <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 flex justify-end gap-2'>
                                <div className='w-[20%]'>
                                    <Autocomplete
                                        value={
                                            payload.currencyCodeValue as unknown as Currency
                                        }
                                        placeholder='Currency'
                                        disableClearable
                                        id='send-currency'
                                        renderInput={(params) => (
                                            <CustomTextField
                                                params={params}
                                                value={payload.currencyCode}
                                                label='Select Currency'
                                                placeholder='Currency'
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment:
                                                        loadingCurrencies && (
                                                            <React.Fragment>
                                                                <CircularProgress
                                                                    size={20}
                                                                />
                                                                {
                                                                    params
                                                                        .InputProps
                                                                        .endAdornment
                                                                }
                                                            </React.Fragment>
                                                        )
                                                }}
                                            />
                                        )}
                                        noOptionsText={'No data available'}
                                        renderOption={(props, option) => (
                                            <MenuItem
                                                {...props}
                                                value={option.name}
                                                key={`countries-${option.id}`}
                                            >
                                                {option.name}
                                            </MenuItem>
                                        )}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(_, value: Currency) => {
                                            if (value !== null) {
                                                updateField(
                                                    'currencyCode',
                                                    value.currencyCode
                                                );
                                                updateField(
                                                    'currencyCodeValue',
                                                    value as unknown as string
                                                );
                                            }
                                        }}
                                        options={currencies}
                                    />
                                </div>
                                <div className='w-[20%]'>
                                    <CustomTextField
                                        disabled
                                        id='quotation-totalAmount'
                                        label='Total Amount'
                                        name='totalAmount'
                                        value={formatDecimalNumber(totalAmount)}
                                        onChange={(
                                            e: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            updateField(
                                                'totalAmount',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </div>

                            <Grid container>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <CustomTextField
                                            value={
                                                payload?.additionalInformation
                                            }
                                            multiline
                                            rows={7.4}
                                            id='quotation-additionalInformation'
                                            label='Additional Information'
                                            name='additionalInformation'
                                            onChange={(
                                                e: ChangeEvent<HTMLInputElement>
                                            ) => {
                                                updateField(
                                                    'additionalInformation',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='border border-appcolorgreyfaint px-[1rem] pt-[1.1rem] pb-4 h-full'>
                                        <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                                marginTop: '0px'
                                            }}
                                        >
                                            <Grid item xs={12} md={12} lg={6}>
                                                <CustomTextField
                                                    value={
                                                        payload?.placeOfIssue
                                                    }
                                                    error={
                                                        errors?.placeOfIssue
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.placeOfIssue
                                                            .length > 0
                                                            ? errors?.placeOfIssue
                                                            : undefined
                                                    }
                                                    required
                                                    id='quotation-placeOfIssue'
                                                    label='Place of Issue'
                                                    name='placeOfIssue'
                                                    onChange={(
                                                        e: ChangeEvent<HTMLInputElement>
                                                    ) => {
                                                        updateField(
                                                            'placeOfIssue',
                                                            e.target.value
                                                        );
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={6}>
                                                <Customdatepicker
                                                    id='quotation-dateOfIssue'
                                                    label='Date of Issue'
                                                    name='dateOfIssue'
                                                    updateField={updateField}
                                                    error={
                                                        errors?.dateOfIssue
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors?.dateOfIssue
                                                            .length > 0
                                                            ? errors?.dateOfIssue
                                                            : undefined
                                                    }
                                                    value={
                                                        payload?.dateOfIssue !==
                                                        undefined
                                                            ? payload?.dateOfIssue
                                                            : null
                                                    }
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={12}>
                                                <div className='my-4'>
                                                    <CustomTextField
                                                        value={
                                                            payload?.signatoryCompany
                                                        }
                                                        error={
                                                            errors
                                                                ?.signatoryCompany
                                                                .length > 0
                                                        }
                                                        helperText={
                                                            errors
                                                                ?.signatoryCompany
                                                                .length > 0
                                                                ? errors?.signatoryCompany
                                                                : undefined
                                                        }
                                                        required
                                                        id='quotation-signatoryCompany'
                                                        label='Signatory Company'
                                                        name='signatoryCompany'
                                                        onChange={(
                                                            e: ChangeEvent<HTMLInputElement>
                                                        ) => {
                                                            updateField(
                                                                'signatoryCompany',
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </Grid>

                                            <Grid item xs={12} md={12} lg={12}>
                                                <CustomTextField
                                                    value={
                                                        payload?.nameOfAuthorisedSignatory
                                                    }
                                                    error={
                                                        errors
                                                            ?.nameOfAuthorisedSignatory
                                                            .length > 0
                                                    }
                                                    helperText={
                                                        errors
                                                            ?.nameOfAuthorisedSignatory
                                                            .length > 0
                                                            ? errors?.nameOfAuthorisedSignatory
                                                            : undefined
                                                    }
                                                    required
                                                    id='quotation-nameOfAuthorisedSignatory'
                                                    label='Name of Authorized Signature'
                                                    name='nameOfAuthorisedSignatory'
                                                    onChange={(
                                                        e: ChangeEvent<HTMLInputElement>
                                                    ) => {
                                                        updateField(
                                                            'nameOfAuthorisedSignatory',
                                                            e.target.value
                                                        );
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={12} lg={12}>
                                                <div className='w-full pt-2'>
                                                    <Signature
                                                        name='signatureUrl'
                                                        updateField={
                                                            updateField
                                                        }
                                                        setSignatureUrlBase64={
                                                            setSignatureUrlBase64
                                                        }
                                                        signatureUrlBase64={
                                                            signatureUrlBase64
                                                        }
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default QuotationForm;
